export enum QueryKey {
  Objects = 'objects',
  Milestones = 'milestones',
  Milestone = 'milestone',
  MilestoneSeq = 'milestoneSeq',
  MilestoneFilter = 'milestoneFilter',
  Organization = 'organization',
  Projects = 'projects',
  Checklist = 'checklist',
  ChecklistAvailability = 'checklistAvailability',
  Permissions = 'permissions',
  Roles = 'roles',
  Users = 'users',
  InvitedUsers = 'invitedUsers',
  Invitation = 'invitation',
  DadataCompanies = 'dadataCompanies',
  DuLabels = 'duLabels',
}
